import { useState, useEffect } from 'react';
import { Input } from '@/components/v4';
import ModalCopy from '@/components/modal/ModalCopy';

const CopyDialPlanModal = ({
    isOpen,
    onClose,
    onCopy,
    planName,
    isLoading,
}) => {
    const [copyName, setCopyName] = useState('');

    useEffect(() => {
        if (isOpen) {
            setCopyName(`${planName} - Copy`);
        }
    }, [isOpen, planName]);

    const handleSubmit = () => {
        onCopy(copyName);
    };

    return (
        <ModalCopy
            isOpen={isOpen}
            handleClose={onClose}
            handleSubmit={handleSubmit}
            type="Dial Plans"
            name={planName}
            isSaving={isLoading}
            isDisabled={!copyName}
            isCentered>
            <Input
                mt={2}
                value={copyName}
                onChange={(e) => setCopyName(e.target.value)}
                placeholder="Enter new dial plan name"
                autoFocus
            />
        </ModalCopy>
    );
};

export default CopyDialPlanModal;
